export default __webpack_public_path__ + "static/media/Mordec Gauntlets.82b9b2b8.jpg";